import { constants } from "redux/constants/redux-constants";

const initialState = {
    isNJTemplateUser: false,
};

export const NJTemplateUserReducer = (state = initialState, action) => {
    switch (action.type) {
      case constants.IS_NJ_TEMPLATE_USER:
        return {
          ...state,
          isNJTemplateUser: action.payload,
        };
      default:
        return state;
    }
};